import './glossaryItem.css';

import { faCircleMinus, faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export default function GlossaryItem ({ item }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const sectionText = { __html: item.definition };

    return (
        <div key={item.term} className="glossary-item">
            <div className="glossary-item-header" onClick={() => setIsExpanded(prev => !prev)}>
                <FontAwesomeIcon icon={isExpanded ? faCircleMinus : faCirclePlus} />
                {" "}
                {item.term}
            </div>
            {isExpanded && <div className="glossary-item-content" dangerouslySetInnerHTML={sectionText}></div>}
        </div>
    );
}